// used as background colors in charts
export const chartColors = [
  "rgba(255, 99, 132, 1)",
  "rgba(54, 162, 235, 1)",
  "rgba(255, 206, 86, 1)",
  "rgba(75, 192, 192, 1)",
  "rgba(153, 102, 255, 1)",
  "rgba(255, 159, 64, 1)",
  "rgba(3, 62, 62, 1)",
  "rgba(41, 52, 98, 1)",
  "rgba(24, 116, 152, 1)",
  "rgba(235, 83, 83, 1)",
];

export const chartColorsV1 = [
  "rgba(255, 99, 132, 0.2)",
  "rgba(54, 162, 235, 0.2)",
  "rgba(255, 206, 86, 0.2)",
  "rgba(75, 192, 192, 0.2)",
  "rgba(153, 102, 255, 0.2)",
  "rgba(255, 159, 64, 0.2)",
  "rgba(3, 62, 62, 0.2)",
  "rgba(41, 52, 98, 0.2)",
  "rgba(24, 116, 152, 0.2)",
  "rgba(235, 83, 83, 0.2)",
];

//used for borders in charts
export const chartColorsV2 = [
  "rgba(255, 99, 132, 0.8)",
  "rgba(54, 162, 235, 0.8)",
  "rgba(255, 206, 86, 0.8)",
  "rgba(75, 192, 192, 0.8)",
  "rgba(153, 102, 255, 0.8)",
  "rgba(255, 159, 64, 0.8)",
  "rgba(3, 62, 62, 0.8)",
  "rgba(41, 52, 98, 0.8)",
  "rgba(24, 116, 152, 0.8)",
  "rgba(235, 83, 83, 0.8)",
];

// Colors for Title background of Charts on dashboard page
export const GREEN_BG_COLOR = "#14C38E";
